<template>
  <nav
    class="main-menu"
    :class="{ show : showMenu } "
  >
    <MainMenuHeader />
    <OmniSearch
      @search-result-updated="showSearchResults"
      @clear="clearSearchResults"
    />

    <ScrollArea>
      <transition
        mode="out-in"
        name="search"
      >
        <MenuEntries
          v-if="!searchResults"
          :module-categories="moduleCategoriesWithGrantedModules"
        />
        <OmniSearchResults
          v-else
          :search-results="searchResults"
          :selected-tab-index.sync="selectedOmniSearchTabIndex"
        />
      </transition>
    </ScrollArea>
    <MainMenuAppStoreButton />
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import GetterTypes from '@/store/constants/getters';
import MainMenuHeader from '@/components/layout/navigation/menu/MainMenuHeader.vue';
import MainMenuAppStoreButton from '@/components/layout/navigation/menu/MainMenuAppStoreButton.vue';
import ScrollArea from '@/components/layout/navigation/menu/ScrollArea.vue';
import OmniSearch from '@/components/layout/navigation/menu/omnisearch/OmniSearch.vue';
import OmniSearchResults from '@/components/layout/navigation/menu/omnisearch/OmniSearchResults.vue';
import MenuEntries from './MainMenuEntries.vue';

export default {
  name: 'MainMenu',
  components: {
    OmniSearchResults,
    ScrollArea,
    OmniSearch,
    MainMenuAppStoreButton,
    MainMenuHeader,
    MenuEntries,
  },
  data() {
    return {
      selectedOmniSearchTabIndex: 0,
      searchResults: null,
    };
  },
  computed: {
    ...mapGetters([
      GetterTypes.MODULE_CATEGORIES_WITH_GRANTED_MODULES,
      GetterTypes.SHOW_MENU,
    ]),
  },
  methods: {
    showSearchResults(searchResults) {
      this.searchResults = searchResults;

      if (searchResults.events.length) {
        this.selectedOmniSearchTabIndex = 0;
      } else if (searchResults.modules.length) {
        this.selectedOmniSearchTabIndex = 1;
      }
    },
    clearSearchResults() {
      this.searchResults = null;
    },
  },
};
</script>

<style lang="scss" scoped>
  $headerHeight: 60px;

  .main-menu {
    max-height: calc(100vh - #{$headerHeight});
    background: var(--primary-bg-hex);
    display: grid;
    grid-template-rows: min-content 70px 1fr;
    grid-gap: 10px;
    z-index: 1;
    box-shadow: 2px 0 11px rgba(var(--shadow-color-rgb), 0.2);

    @media (max-width: $mediumLargeBreakpoint) {
      &.show {
        transform: translateX(0);
      }

      transition: transform 0.6s;
      transform: translateX(-100%);
      position: fixed;
      min-height: calc(100vh - #{$headerHeight});
      top: $headerHeight;
      z-index: 999;
      width: 100%;
      max-width: 411px;
    }
  }

  .search-enter-active,
  .search-leave-active {
    transition: opacity 0.15s;
  }

  .search-enter,
  .search-leave-to {
    opacity: 0;
  }
</style>
